import React, { useEffect, useState, useRef, useCallback } from "react";
import { toast } from "react-toastify";
import { getData, postDataWithBody, putDataWithBody } from "../../../Services/Services";
import { createassignroute, getroutname, updateplannedroute, getgeofences, getThemeURL, findAllGeofenceChildrenRegionsById, gisCoordinatesData, gisBlockCoordinatesData, gisStateCoordinates, getroutlatlonnew, geofenceByRoute, getAllVehicles } from "../../../Services/EndPoints";
import Tree from "rc-tree";
import "rc-tree/assets/index.css";
import './Geofence.css';
import { useNavigate } from "react-router-dom";
import { GoogleMap, Marker, InfoWindow, Polyline, Circle, Polygon, useJsApiLoader, TransitLayer } from "@react-google-maps/api";
import LoadingOverlay from "../ExpectedTrackForm/LoadingOverlay";
import SearchableRouteDropdown from "../ExpectedTrackForm/SearchableRouteDropdown";
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_LIBRARIES, GOOGLE_MAPS_LOADER_ID } from "../GpsTrackManagement/Googlemapsloader";

// Map container style
const mapContainerStyle = {
    width: '100%',
    height: '100%'
};

// Default map options
const defaultMapOptions = {
    mapTypeControl: false,
    streetViewControl: true,
    fullscreenControl: false,
    zoomControl: true,
    clickableIcons: false,
    gestureHandling: 'greedy',
};

// Map libraries needed
// const libraries = ["places"];

// Map type IDs
const mapTypes = {
    road: 'roadmap',
    satellite: 'satellite',
    hybrid: 'hybrid',
    terrain: 'terrain'
};

const AssignGeofencing = ({ edit, editData, onEditModeChange }) => {
    const navigate = useNavigate();
    const mapRef = useRef(null);
    const mapPanelRef = useRef(null);
    const geocoderRef = useRef(null);
    const autocompleteRef = useRef(null);
    const searchTimerRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isMapLoaded, setIsMapLoaded] = useState(false);
    const [vehicles, setVehicles] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [isLoadingWaypoints, setIsLoadingWaypoints] = useState(false);
    const [waypoints, setWaypoints] = useState([]);
    // Geofence states
    const [geofences, setGeofences] = useState([]);
    const [routeGeofences, setRouteGeofences] = useState([]);
    const [isLoadingGeofences, setIsLoadingGeofences] = useState(false);
    const [selectedGeofence, setSelectedGeofence] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    // Map states
    const [mapCenter, setMapCenter] = useState({ lat: 17.385044, lng: 78.486671 });
    const [mapZoom, setMapZoom] = useState(12);
    const [selectedLayer, setSelectedLayer] = useState('road');
    const [showLayerControl, setShowLayerControl] = useState(false);
    const [showTransit, setShowTransit] = useState(false);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [userId, setUserId] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [hoveredPolygon, setHoveredPolygon] = useState(null); // { name, x, y } pixel coords

    console.log("mapcenter", setMapCenter)

    console.log("mapcenter2", setMapZoom)

    const [formData, setFormData] = useState({
        vehicleIds: [],
        routeId: '',
        fromDateTime: '',
        toDateTime: '',
        fromTime: '',
        toTime: '',
        geofenceId: '',
        alertType: '',
        speedAlertKmh: '',
        dwellHours: '',
        dwellMins: ''
    });
    const [vehicleDropdownOpen, setVehicleDropdownOpen] = useState(false);
    const [vehicleSearch, setVehicleSearch] = useState('');

    const [addressCache, setAddressCache] = useState({});

    // District-tree states
    const [selectionMode, setSelectionMode] = useState('geofence'); // 'geofence' | 'district'
    const [regionTreeCollapsed, setRegionTreeCollapsed] = useState(false);
    const [stateId, setStateId] = useState(82);
    const [stateName, setStateName] = useState('STATE');
    const [regionTreeData, setRegionTreeData] = useState([]);
    const [regionExpandedKeys, setRegionExpandedKeys] = useState([]);
    const [regionCheckedKeys, setRegionCheckedKeys] = useState([]);
    const [districtPolygons, setDistrictPolygons] = useState([]); // [{gisId, paths, name}]
    const [regionCheckLoading, setRegionCheckLoading] = useState(false);
    const regionDataMapRef = useRef(new Map());
    const routeRegionRef = useRef(null); // persists route's { regionId, ogcFid } across tab switches
    const [selectedOgcFid, setSelectedOgcFid] = useState(null);
    const [selectedOgcType, setSelectedOgcType] = useState('');
    const [selectedRegionId, setSelectedRegionId] = useState(null);
    const [pendingAutoRegion, setPendingAutoRegion] = useState(null); // { regionId, ogcFid }
    useEffect(() => {
        const style = document.createElement('style');
        style.id = 'gm-hover-suppress';
        style.textContent = '.gm-style .gm-style-pbc,.gm-style-pbc,.gm-style .gm-style-pbt,.gm-style-pbt{display:none!important;pointer-events:none!important;}';
        document.head.appendChild(style);
        return () => { const el = document.getElementById('gm-hover-suppress'); if (el) el.remove(); };
    }, []);

    useEffect(() => {
        const handler = () => setIsFullscreen(document.fullscreenElement === mapPanelRef.current);
        document.addEventListener('fullscreenchange', handler);
        return () => document.removeEventListener('fullscreenchange', handler);
    }, []);

    useEffect(() => {
        if (mapRef.current && window.google?.maps) {
            window.google.maps.event.trigger(mapRef.current, 'resize');
        }
    }, [isFullscreen]);

    const { isLoaded: isMapsApiReady } = useJsApiLoader({
        id: GOOGLE_MAPS_LOADER_ID,
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
        libraries: GOOGLE_MAPS_LIBRARIES,
    });
console.log("stateid",setStateId)
    const HALT_SVG_URL = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
        `<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
          <circle cx="17" cy="17" r="16" fill="#ffc107" stroke="#ffffff" stroke-width="2"/>
          <rect x="10" y="10" width="5" height="14" rx="1.5" fill="#ffffff"/>
          <rect x="19" y="10" width="5" height="14" rx="1.5" fill="#ffffff"/>
        </svg>`
    )}`;

    // Custom marker icons
    const createMarkerIcon = (color, type) => {
        if (!window.google) return null;

        if (type === 'start') {
            return {
                url: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
                scaledSize: new window.google.maps.Size(25, 41),
                anchor: new window.google.maps.Point(12, 41),
                labelOrigin: new window.google.maps.Point(12, 14),
            };
        } else if (type === 'end') {
            return {
                url: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
                scaledSize: new window.google.maps.Size(25, 41),
                anchor: new window.google.maps.Point(12, 41),
                labelOrigin: new window.google.maps.Point(12, 14),
            };
        } else if (type === 'halt') {
            return {
                url: HALT_SVG_URL,
                scaledSize: new window.google.maps.Size(34, 34),
                anchor: new window.google.maps.Point(17, 17),
            };
        } else {
            return {
                path: window.google.maps.SymbolPath.CIRCLE,
                fillColor: '#1a7a73',
                fillOpacity: 1,
                strokeColor: '#FFFFFF',
                strokeWeight: 2,
                scale: 8,
                anchor: new window.google.maps.Point(0, 0)
            };
        }
    };

    const getIconColor = (type) => {
        switch (type?.toLowerCase()) {
            case 'start': return '#28a745';
            case 'end': return '#dc3545';
            case 'halt': return '#ffc107';
            default: return '#1a7a73';
        }
    };

    const fetchAddress = async (lat, lng, key) => {
        if (addressCache[key]) return;
        try {
            const res = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`
            );
            const data = await res.json();

            if (data.results && data.results[0]) {
                const components = data.results[0].address_components;

                const get = (types) => {
                    const c = components.find(c => types.some(t => c.types.includes(t)));
                    return c ? c.long_name : '';
                };

                const road = get(['route']);
                const sublocal2 = get(['sublocality_level_2']);
                const sublocal1 = get(['sublocality_level_1']);
                const city = get(['locality']);
                const state = get(['administrative_area_level_1']);
                const pincode = get(['postal_code']);

                const parts = [road, sublocal2, sublocal1, city, state, pincode].filter(Boolean);
                const address = parts.join(', ');

                setAddressCache(prev => ({ ...prev, [key]: address || 'Address not found' }));
            } else {
                setAddressCache(prev => ({ ...prev, [key]: 'Address not found' }));
            }
        } catch {
            setAddressCache(prev => ({ ...prev, [key]: 'Address not found' }));
        }
    };

    // Map load callback
    const onMapLoad = useCallback((map) => {
        mapRef.current = map;
        setIsMapLoaded(true);
        if (window.google?.maps) {
            geocoderRef.current = new window.google.maps.Geocoder();
            autocompleteRef.current = new window.google.maps.places.AutocompleteService();
        }
    }, []);

    // Location search
    const searchLocation = (query) => {
        if (!query.trim() || !autocompleteRef.current) { setSearchResults([]); return; }
        setIsSearching(true);
        autocompleteRef.current.getPlacePredictions(
            { input: query, componentRestrictions: { country: 'in' } },
            (predictions, status) => {
                setIsSearching(false);
                if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
                    setSearchResults(predictions);
                } else {
                    setSearchResults([]);
                }
            }
        );
    };

    const selectSearchResult = (place) => {
        setSearchQuery(place.description);
        setSearchResults([]);
        if (!geocoderRef.current) return;
        geocoderRef.current.geocode({ placeId: place.place_id }, (results, status) => {
            if (status === 'OK' && results[0]) {
                const viewport = results[0].geometry.viewport;
                if (viewport) {
                    mapRef.current.fitBounds(viewport);
                } else {
                    const loc = results[0].geometry.location;
                    mapRef.current.setCenter({ lat: loc.lat(), lng: loc.lng() });
                    mapRef.current.setZoom(15);
                }
            }
        });
    };

    const handleSearchInputChange = (e) => {
        const val = e.target.value;
        setSearchQuery(val);
        if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
        searchTimerRef.current = setTimeout(() => searchLocation(val), 500);
    };

    const clearSearch = () => {
        setSearchQuery('');
        setSearchResults([]);
        if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    };

    // Map error callback
    // const onMapError = useCallback(() => {
    //     console.error("Failed to load Google Maps");
    //     toast.error("Failed to load Google Maps. Please check your API key and internet connection.");
    // }, []);

    useEffect(() => {
        if (edit && editData) {
            setIsEditMode(true);
            if (vehicles.length > 0 && routes.length > 0) {
                populateEditData(editData);
            }
        } else {
            setIsEditMode(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [edit, editData, vehicles, routes]);

    useEffect(() => {
        fetchVehicles();
        fetchRoutes();
       // fetchGeofences();
        fetchUserProfile();
    }, []);

    const fetchUserProfile = async () => {
        try {
            const response = await getData(getThemeURL);
            if (response && Array.isArray(response) && response.length > 0) {
                console.log("responseee", response)
                setUserId(response[0].id);
                // setStateId(response[0].state_id || null);
                setStateName(response[0].statename || 'TELANGANA');
            }
        } catch (error) {
            console.error("Error fetching user profile:", error);
        }
    };

    // Fetch waypoints when route selected
    useEffect(() => {
        const fetchWaypointsForRoute = async () => {
            if (selectedRoute && selectedRoute.routeId) {
                try {
                    setIsLoadingWaypoints(true);
                    const waypointsResponse = await getData(getroutlatlonnew.replace('ID', selectedRoute.routeId));

                    let waypointsList = [];
                    let routeRegionId = null;
                    let routeOgcFid = null;

                    if (Array.isArray(waypointsResponse)) {
                        waypointsList = waypointsResponse;
                    } else if (waypointsResponse && waypointsResponse.waypoints) {
                        waypointsList = waypointsResponse.waypoints;
                        routeRegionId = waypointsResponse.regionId || null;
                        routeOgcFid = waypointsResponse.ogcFid || null;
                    }

                    setWaypoints(waypointsList);

                    if (waypointsList.length > 0 && mapRef.current && isMapLoaded) {
                        const bounds = new window.google.maps.LatLngBounds();
                        waypointsList.forEach(point => {
                            bounds.extend({
                                lat: parseFloat(point.latitude),
                                lng: parseFloat(point.longitude)
                            });
                        });
                        mapRef.current.fitBounds(bounds, 20);
                    }

                    if (routeRegionId) {
                        routeRegionRef.current = { regionId: routeRegionId, ogcFid: routeOgcFid };
                        setPendingAutoRegion({ regionId: routeRegionId, ogcFid: routeOgcFid });
                        setSelectionMode('district');
                        setRegionTreeCollapsed(false);
                    } else {
                        routeRegionRef.current = null;
                    }

                    // Fetch geofences linked to this route
                    try {
                        const gfResponse = await getData(geofenceByRoute + selectedRoute.routeId);
                        const gfData = gfResponse && gfResponse.success && Array.isArray(gfResponse.data)
                            ? gfResponse.data
                            : Array.isArray(gfResponse) ? gfResponse : [];
                        setRouteGeofences(gfData);
                        // Always clear geofenceId — user must select manually from dropdown
                        setFormData(prev => ({ ...prev, geofenceId: '', alertType: '' }));
                        setSelectedGeofence(null);
                    } catch {
                        setRouteGeofences([]);
                    }
                } catch (error) {
                    console.error('Error fetching waypoints:', error);
                    setWaypoints([]);
                    toast.error('Failed to fetch route waypoints');
                } finally {
                    setIsLoadingWaypoints(false);
                }
            } else {
                setWaypoints([]);
                setRouteGeofences([]);
            }
        };

        fetchWaypointsForRoute();
    }, [selectedRoute, isMapLoaded]);

    // Update selectedGeofence when geofenceId changes
    useEffect(() => {
        if (formData.geofenceId) {
            const pool = routeGeofences.length > 0 ? routeGeofences : geofences;
            const geofence = pool.find(g => g.id === parseInt(formData.geofenceId));
            setSelectedGeofence(geofence || null);

            // Pan map to geofence location
            if (geofence && mapRef.current && isMapLoaded) {
                const geo = geofence.geometry;
                if (geo.type === 'Circle' && geo.center) {
                    mapRef.current.panTo({ lat: geo.center.lat, lng: geo.center.lng });
                    mapRef.current.setZoom(15);
                } else if (geo.type === 'Polygon' && geo.coordinates?.length > 0) {
                    const bounds = new window.google.maps.LatLngBounds();
                    geo.coordinates.forEach(c => {
                        bounds.extend({ lat: c[1], lng: c[0] });
                    });
                    mapRef.current.fitBounds(bounds, 30);
                } else if (geo.type === 'LineString' && geo.coordinates?.length > 0) {
                    const bounds = new window.google.maps.LatLngBounds();
                    geo.coordinates.forEach(c => {
                        bounds.extend({ lat: c[1], lng: c[0] });
                    });
                    mapRef.current.fitBounds(bounds, 30);
                }
            }
        } else {
            setSelectedGeofence(null);
        }
    }, [formData.geofenceId, geofences, routeGeofences, isMapLoaded]);

    const populateEditData = (data) => {
        const parseDateTime = (dateTimeStr) => {
            const cleanStr = dateTimeStr.trim();

            if (cleanStr.includes(',')) {
                const [datePart, timePart] = cleanStr.split(',').map(s => s.trim());
                const [day, month, year] = datePart.split('-');
                return {
                    date: `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`,
                    time: timePart
                };
            }

            if (cleanStr.includes(' ')) {
                const [datePart, timePart] = cleanStr.split(' ');
                const timeOnly = timePart.substring(0, 5);
                return { date: datePart, time: timeOnly };
            }

            const dt = new Date(cleanStr);
            const date = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
            const time = `${String(dt.getHours()).padStart(2, '0')}:${String(dt.getMinutes()).padStart(2, '0')}`;
            return { date, time };
        };

        const startDateTime = parseDateTime(data.startDate);
        const endDateTime = parseDateTime(data.endDate);

        const vehicle = vehicles.find(v => v.vehicleNumber === data.vehicleNumber);
        const route = routes.find(r => r.routeId === data.routeId);

        setFormData({
            vehicleIds: vehicle ? [vehicle.id] : [],
            routeId: route ? route.id.toString() : '',
            fromDateTime: startDateTime.date,
            toDateTime: endDateTime.date,
            fromTime: startDateTime.time,
            toTime: endDateTime.time,
            geofenceId: data.geofenceId ? data.geofenceId.toString() : '',
            alertType: data.alertType || '',
            speedAlertKmh: data.speedAlertKmh != null ? String(data.speedAlertKmh) : '',
            // API stores dwell as total minutes — split into hours + minutes for the form
            dwellHours: data.dwellAlertMinutes != null ? String(Math.floor(data.dwellAlertMinutes / 60)) : '',
            dwellMins: data.dwellAlertMinutes != null ? String(data.dwellAlertMinutes % 60) : ''
        });

        if (route) setSelectedRoute(route);
    };

    const fetchVehicles = async () => {
        try {
            setIsLoading(true);
            // const response = await getData(getvehicles);
            const response = await getData(getAllVehicles);
            if (Array.isArray(response)) {
                setVehicles(response.map((v) => ({
                    id: v.id, vehicleNumber: v.vehicle_number, vehicleName: v.vehicle_number,
                })));
            }
        } catch (error) {
            console.error('Error fetching vehicles:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchRoutes = async () => {
        try {
            const response = await getData(getroutname);
            if (response) setRoutes(response);
        } catch (error) {
            console.error('Error fetching routes:', error);
        }
    };

    // Kept for re-enabling the all-geofences load (call is commented out above)
    // eslint-disable-next-line no-unused-vars
    const fetchGeofences = async () => {
        try {
            setIsLoadingGeofences(true);
            const response = await getData(getgeofences);

            let geoData = [];

            if (Array.isArray(response)) {
                geoData = response;
            } else if (response && response.success && Array.isArray(response.data)) {
                geoData = response.data;
            }

            // ✅ Convert backend date array to proper JS Date
            const parseDate = (arr) => {
                return new Date(
                    arr[0],          // year
                    arr[1] - 1,      // 🔥 FIX: month (0-based)
                    arr[2],
                    arr[3] || 0,
                    arr[4] || 0,
                    arr[5] || 0,
                    Math.floor((arr[6] || 0) / 1000000) // ns → ms
                );
            };

            // ✅ Sort latest first
            const sortedGeofences = geoData.sort((a, b) => {
                const dateA = parseDate(a.createdAt);
                const dateB = parseDate(b.createdAt);
                return dateB - dateA;
            });

            setGeofences(sortedGeofences);

        } catch (error) {
            console.error('Error fetching geofences:', error);
        } finally {
            setIsLoadingGeofences(false);
        }
    };

    // ── District tree: init when mode switches to 'district' ─────────────────
    useEffect(() => {
        if (selectionMode !== 'district' || !stateId) return;
        const stateKey = String(stateId);
        regionDataMapRef.current.set(stateKey, { id: stateId, name: stateName, level: 0, gis_id: null });
        setRegionTreeData([{ title: stateName, key: stateKey, checkable: true }]);
        setRegionExpandedKeys([]);
        setRegionCheckedKeys([]);
        setDistrictPolygons([]);

        // Eagerly load district children — rc-tree's loadData is only triggered
        // by user clicks, not programmatic expandedKeys, so we fetch manually.
        postDataWithBody(findAllGeofenceChildrenRegionsById, [String(stateId)], {})
            .then(children => {
                const childNodes = (Array.isArray(children) ? children : []).map(region => {
                    const childKey = `${stateKey}-${region.id}`;
                    regionDataMapRef.current.set(childKey, {
                        id: region.id, name: region.name,
                        gis_id: region.gis_id, region_type_id: region.region_type_id, level: 1
                    });
                    return { title: region.name, key: childKey, isLeaf: false, checkable: true };
                });
                setRegionTreeData([{ title: stateName, key: stateKey, checkable: true, children: childNodes }]);
                setRegionExpandedKeys([stateKey]);
            })
            .catch(err => console.error('Failed to load district children:', err));
    }, [selectionMode, stateId, stateName]); // eslint-disable-line react-hooks/exhaustive-deps

    // ── Auto-check region from route's regionId ───────────────────────────────
    useEffect(() => {
        if (!pendingAutoRegion) return;
        const { regionId } = pendingAutoRegion;

        // Pass 1: find by regionId directly (state or district already in tree)
        let foundKey = null;
        regionDataMapRef.current.forEach((data, key) => {
            if (data.id === regionId) foundKey = key;
        });

        if (foundKey) {
            setPendingAutoRegion(null);
            onRegionCheck([foundKey], { checked: true, node: { key: foundKey } });
            return;
        }

        // Pass 2: regionId is a block — search all district children in parallel
        const districtEntries = [];
        regionDataMapRef.current.forEach((data, key) => {
            if (data.level === 1) districtEntries.push({ key, data });
        });
        if (districtEntries.length === 0) return; // districts not yet loaded

        setPendingAutoRegion(null);
        (async () => {
            const results = await Promise.all(
                districtEntries.map(async ({ key: distKey, data: distData }) => {
                    try {
                        const blocks = await postDataWithBody(findAllGeofenceChildrenRegionsById, [String(distData.id)], {});
                        const match = (Array.isArray(blocks) ? blocks : []).find(b => b.id === regionId);
                        return match ? { distKey, match } : null;
                    } catch { return null; }
                })
            );

            const found = results.find(Boolean);
            if (!found) return;

            const { distKey, match } = found;
            const blockKey = `${distKey}-${match.id}`;
            regionDataMapRef.current.set(blockKey, {
                id: match.id, name: match.name,
                gis_id: match.gis_id, region_type_id: match.region_type_id, level: 2
            });
            setRegionExpandedKeys(prev => prev.includes(distKey) ? prev : [...prev, distKey]);
            onRegionCheck([blockKey], { checked: true, node: { key: blockKey } });
        })();
    }, [pendingAutoRegion, regionTreeData]); // eslint-disable-line react-hooks/exhaustive-deps

    // ── Add children to a node inside tree data ───────────────────────────────
    const addChildrenToTree = (nodes, targetKey, children) =>
        nodes.map(node => {
            if (node.key === targetKey) return { ...node, children };
            if (node.children) return { ...node, children: addChildrenToTree(node.children, targetKey, children) };
            return node;
        });

    // ── Convert GeoJSON polygon to Google Maps paths ──────────────────────────
    const geoJsonToGooglePaths = (geoJson) => {
        if (!geoJson) return [];
        if (geoJson.type === 'Polygon')
            return geoJson.coordinates.map(ring => ring.map(([lng, lat]) => ({ lat, lng })));
        if (geoJson.type === 'MultiPolygon')
            return geoJson.coordinates.flatMap(poly => poly.map(ring => ring.map(([lng, lat]) => ({ lat, lng }))));
        return [];
    };

    // ── Lazy-load children via the geofence-region API ───────────────────────
    const loadRegionChildren = async (node) => {
        const key = node.key;
        const parts = key.split('-');
        const nodeId = parts[parts.length - 1];
        const level = parts.length - 1;

        try {
            const children = await postDataWithBody(findAllGeofenceChildrenRegionsById, [nodeId], {});
            const childNodes = (Array.isArray(children) ? children : []).map(region => {
                const childKey = `${key}-${region.id}`;
                const childLevel = level + 1;
                regionDataMapRef.current.set(childKey, {
                    id: region.id, name: region.name,
                    gis_id: region.gis_id, region_type_id: region.region_type_id, level: childLevel
                });
                return { title: region.name, key: childKey, isLeaf: childLevel >= 2, checkable: true };
            });
            setRegionTreeData(prev => addChildrenToTree(prev, key, childNodes));
        } catch (err) {
            console.error('Failed to load region children:', err);
        }
    };

    // ── Geofence color by category ───────────────────────────────────────────
    const CATEGORY_COLORS = {
        'Depot': '#1a7a73',
        'Restricted Zone': '#dc2626',
        'Customer Site': '#2563eb',
        'Parking': '#7c3aed',
        'Warehouse': '#d97706',
        'Toll Zone': '#0891b2',
        'No-Entry Zone': '#991b1b',
    };
    const categoryColor = (category) => CATEGORY_COLORS[category] || null;

    // ── Polygon color by region level ────────────────────────────────────────
    const polygonColorByLevel = (level) => {
        if (level === 0) return { stroke: '#1a7a73', fill: '#1a7a73', opacity: 0.15 }; // state  – blue
        if (level === 1) return { stroke: '#10b981', fill: '#10b981', opacity: 0.18 }; // district – green
        return { stroke: '#f97316', fill: '#f97316', opacity: 0.22 };    // block    – orange
    };

    const levelToOgcType = (level) => {
        if (level === 0) return 'state';
        if (level === 1) return 'district';
        return 'block';
    };

    // ── Check/uncheck a region node → fetch/remove polygon ───────────────────
    const onRegionCheck = async (checkedKeysValue, info) => {
        const checked = Array.isArray(checkedKeysValue)
            ? checkedKeysValue
            : (checkedKeysValue.checked || []);

        const nodeKey = info.node.key;
        const nodeData = regionDataMapRef.current.get(nodeKey);
        if (!nodeData) return;

        const level = nodeData.level ?? 1;

        setRegionCheckLoading(true);
        try {
        if (info.checked) {
            // ── Fetch this node's own polygon ────────────────────────────────
            const gisParam = level === 0 ? nodeData.id : nodeData.gis_id;
            // For level 0 (state): ogc_fid comes from API response, set after fetch
            if (level !== 0) setSelectedOgcFid(gisParam || null);
            setSelectedOgcType(levelToOgcType(level));
            setSelectedRegionId(nodeData.id != null ? `${nodeData.id}-${nodeData.name}` : null);
            let ownPolygon = null;
            if (gisParam) {
                try {
                    const geoEndpoint = level === 0
                        ? gisStateCoordinates
                        : level >= 2 ? gisBlockCoordinatesData : gisCoordinatesData;
                    const res = await getData(geoEndpoint + gisParam);
                    if (res && res.length > 0) {
                        // For state (level 0): use ogc_fid from API response, not the state_id
                        if (level === 0) {
                            setSelectedOgcFid(res[0].ogc_fid ?? gisParam);
                        }
                        const paths = geoJsonToGooglePaths(JSON.parse(res[0].coordinates));
                        ownPolygon = { gisId: gisParam, paths, name: nodeData.name, level };
                    }
                } catch (err) {
                    console.error('Failed to fetch region geometry:', err);
                }
            }

            // ── If district (level 1): auto-load blocks, check & show them ──
            let blockCheckedKeys = [];
            let blockPolygons = [];
            if (level === 1) {
                try {
                    const blocks = await postDataWithBody(
                        findAllGeofenceChildrenRegionsById, [String(nodeData.id)], {}
                    );
                    const blockNodes = (Array.isArray(blocks) ? blocks : []).map(block => {
                        const blockKey = `${nodeKey}-${block.id}`;
                        regionDataMapRef.current.set(blockKey, {
                            id: block.id, name: block.name,
                            gis_id: block.gis_id, region_type_id: block.region_type_id, level: 2
                        });
                        return { title: block.name, key: blockKey, isLeaf: true, checkable: true };
                    });

                    // Inject block nodes into the tree & expand district
                    setRegionTreeData(prev => addChildrenToTree(prev, nodeKey, blockNodes));
                    setRegionExpandedKeys(prev =>
                        prev.includes(nodeKey) ? prev : [...prev, nodeKey]
                    );

                    blockCheckedKeys = blockNodes.map(n => n.key);

                    // Fetch all block polygons in parallel
                    const results = await Promise.all(
                        blockNodes.map(async (bn) => {
                            const bd = regionDataMapRef.current.get(bn.key);
                            if (!bd?.gis_id) return null;
                            try {
                                const res = await getData(gisBlockCoordinatesData + bd.gis_id);
                                if (res && res.length > 0) {
                                    const paths = geoJsonToGooglePaths(JSON.parse(res[0].coordinates));
                                    return { gisId: bd.gis_id, paths, name: bd.name, level: 2 };
                                }
                            } catch { /* skip */ }
                            return null;
                        })
                    );
                    blockPolygons = results.filter(Boolean);
                } catch (err) {
                    console.error('Failed to auto-load blocks for district:', err);
                }
            }

            // ── Commit checked keys & polygons ───────────────────────────────
            setRegionCheckedKeys([...checked, ...blockCheckedKeys]);
            setDistrictPolygons(prev => {
                const blockGisIds = blockPolygons.map(p => p.gisId);
                const filtered = prev
                    .filter(p => gisParam ? p.gisId !== gisParam : true)
                    .filter(p => !blockGisIds.includes(p.gisId));
                return [...filtered, ...(ownPolygon ? [ownPolygon] : []), ...blockPolygons];
            });

            // Pan map to cover all new polygons
            const allPaths = [
                ...(ownPolygon ? ownPolygon.paths : []),
                ...blockPolygons.flatMap(p => p.paths)
            ];
            if (allPaths.length > 0 && mapRef.current && isMapLoaded) {
                const bounds = new window.google.maps.LatLngBounds();
                allPaths.forEach(ring => ring.forEach(pt => bounds.extend(pt)));
                mapRef.current.fitBounds(bounds, 30);
            }

        } else {
            // ── Uncheck: remove own polygon + all child block polygons ───────
            const gisParam = level === 0 ? nodeData.id : nodeData.gis_id;
            const blockGisIds = [];
            const blockKeysToRemove = [];

            if (level === 1) {
                regionDataMapRef.current.forEach((data, key) => {
                    if (key.startsWith(nodeKey + '-') && data.level === 2) {
                        blockKeysToRemove.push(key);
                        if (data.gis_id) blockGisIds.push(data.gis_id);
                    }
                });
            }

            const remainingKeys = checked.filter(k => !blockKeysToRemove.includes(k));
            setRegionCheckedKeys(remainingKeys);
            setDistrictPolygons(prev =>
                prev.filter(p => p.gisId !== gisParam && !blockGisIds.includes(p.gisId))
            );
            if (remainingKeys.length === 0) {
                setSelectedOgcFid(null);
                setSelectedOgcType('');
                setSelectedRegionId(null);
            }
        }
        } finally {
            setRegionCheckLoading(false);
        }
    };

    const resetForm = () => {
        setFormData({
            vehicleIds: [],
            routeId: '',
            fromDateTime: '',
            toDateTime: '',
            fromTime: '',
            toTime: '',
            geofenceId: '',
            alertType: '',
            speedAlertKmh: '',
            dwellHours: '',
            dwellMins: ''
        });
        setSelectedRoute(null);
        setSelectedGeofence(null);
        setWaypoints([]);
        setRouteGeofences([]);
        routeRegionRef.current = null;
        setSelectedMarker(null);
        setSelectedOgcFid(null);
        setSelectedOgcType('');
        setSelectedRegionId(null);
        // Reset district/region tree selections and polygons
        setRegionCheckedKeys([]);
        setRegionExpandedKeys([]);
        setDistrictPolygons([]);
        // Re-seed the tree with just the state root so it's ready for next use
        if (selectionMode === 'district' && stateId) {
            const stateKey = String(stateId);
            regionDataMapRef.current.clear();
            regionDataMapRef.current.set(stateKey, { id: stateId, name: stateName, level: 0, gis_id: null });
            setRegionTreeData([{ title: stateName, key: stateKey, checkable: true }]);
        }
    };

    const getCurrentTime = () => {
        const now = new Date();
        return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    };

    const isToday = (dateString) => {
        if (!dateString) return false;
        const today = new Date();
        const checkDate = new Date(dateString);
        return today.toDateString() === checkDate.toDateString();
    };

    const handleInputChange = (e) => {
        const { name } = e.target;
        let { value } = e.target;

        // Alert thresholds accept whole numbers only
        if (name === 'speedAlertKmh' || name === 'dwellHours' || name === 'dwellMins') {
            value = value.replace(/\D/g, '');
        }
        if (name === 'dwellMins' && value !== '' && Number(value) > 59) value = '59';

        const updatedFormData = { ...formData, [name]: value };

        // Dwell alert only applies to IN alerts
        if (name === 'alertType' && value === 'OUT') {
            updatedFormData.dwellHours = '';
            updatedFormData.dwellMins = '';
        }

        // Clear alertType if geofence is cleared
        if (name === 'geofenceId' && !value) {
            updatedFormData.alertType = '';
        }

        if (isEditMode && (name === 'fromDateTime' || name === 'toDateTime')) {
            const fromDate = name === 'fromDateTime' ? value : updatedFormData.fromDateTime;
            const toDate = name === 'toDateTime' ? value : updatedFormData.toDateTime;
            if (fromDate && toDate && fromDate !== toDate) {
                toast.error('From date and To date must be the same in edit mode.', {
                    position: 'top-center', autoClose: 4000,
                });
            }
        }

        if (name === 'fromDateTime' || name === 'toDateTime') {
            if (updatedFormData.fromDateTime && updatedFormData.toDateTime) {
                const fromDate = new Date(updatedFormData.fromDateTime);
                const toDate = new Date(updatedFormData.toDateTime);
                fromDate.setHours(0, 0, 0, 0);
                toDate.setHours(0, 0, 0, 0);
                if (toDate < fromDate) {
                    toast.error('To Date should be greater than or equal to From Date', {
                        position: 'top-center', autoClose: 4000,
                    });
                }
            }
        }

        if (name === 'fromTime' || name === 'toTime') {
            const currentTime = getCurrentTime();
            if (name === 'fromTime' && isToday(updatedFormData.fromDateTime) && value < currentTime) {
                toast.error('From time cannot be in the past for today', { position: 'top-center', autoClose: 4000 });
                return;
            }
            if (name === 'toTime' && isToday(updatedFormData.toDateTime) && value < currentTime) {
                toast.error('To time cannot be in the past for today', { position: 'top-center', autoClose: 4000 });
                return;
            }
        }

        if (updatedFormData.fromTime && updatedFormData.toTime) {
            const [fh, fm] = updatedFormData.fromTime.split(':');
            const [th, tm] = updatedFormData.toTime.split(':');
            if (parseInt(th) * 60 + parseInt(tm) <= parseInt(fh) * 60 + parseInt(fm)) {
                toast.error('To time must be after from time (this schedule applies to each day in the date range)', {
                    position: 'top-center',
                });
            }
        }

        setFormData(updatedFormData);
    };

    const validateAssignForm = () => {
        if (!formData.vehicleIds.length) { toast.error('Please select at least one vehicle', { position: "top-center" }); return false; }
        if (!formData.routeId) { toast.error('Please select a route', { position: "top-center" }); return false; }
        if (!formData.fromDateTime) { toast.error('Please select from date', { position: "top-center" }); return false; }
        if (!formData.toDateTime) { toast.error('Please select to date', { position: "top-center" }); return false; }
        if (!formData.fromTime) { toast.error('Please select from time', { position: "top-center" }); return false; }
        if (!formData.toTime) { toast.error('Please select to time', { position: "top-center" }); return false; }
        if (selectionMode === 'geofence') {
            if (!formData.geofenceId) { toast.error('Please select a geofence', { position: "top-center" }); return false; }
            if (!formData.alertType) { toast.error('Please select an alert type', { position: "top-center" }); return false; }
        } else {
            if (regionCheckedKeys.length === 0) { toast.error('Please select at least one district', { position: "top-center" }); return false; }
            if (!formData.alertType) { toast.error('Please select an alert type', { position: "top-center" }); return false; }
        }

        const currentTime = getCurrentTime();
        if (isToday(formData.fromDateTime) && formData.fromTime < currentTime) {
            toast.error('From time cannot be in the past for today', { position: "top-center" }); return false;
        }
        if (isToday(formData.toDateTime) && formData.toTime < currentTime) {
            toast.error('To time cannot be in the past for today', { position: "top-center" }); return false;
        }
        if (isEditMode && formData.fromDateTime !== formData.toDateTime) {
            toast.error('From date and To date must be the same in edit mode.', { position: 'top-center' }); return false;
        }

        const fromDate = new Date(formData.fromDateTime);
        const toDate = new Date(formData.toDateTime);

        if (formData.fromTime && formData.toTime) {
            const [fh, fm] = formData.fromTime.split(':');
            const [th, tm] = formData.toTime.split(':');
            const fromMins = parseInt(fh) * 60 + parseInt(fm);
            const toMins = parseInt(th) * 60 + parseInt(tm);
            if (toMins <= fromMins) {
                toast.error('To time must be after from time', { position: "top-center" }); return false;
            }
            fromDate.setHours(parseInt(fh), parseInt(fm), 0);
            toDate.setHours(parseInt(th), parseInt(tm), 0);
        }

        if (fromDate > toDate) {
            toast.error('To date must be after from date', { position: "top-center" }); return false;
        }

        return true;
    };

    // Build geofence payload fields
    const buildGeofencePayload = () => {
        if (formData.geofenceId && selectedGeofence) {
            return {
                geofenceId: parseInt(formData.geofenceId, 10),
                geofenceName: selectedGeofence.name || '',
                alertType: formData.alertType ? formData.alertType.toUpperCase() : ''
            };
        }
        return {
            geofenceId: null,
            geofenceName: '',
            alertType: ''
        };
    };

    const buildAdministrativeFields = () => {
        if (selectionMode === 'district') {
            return {
                is_administrative: true,
                ogc_fid: selectedOgcFid,
                ogc_type: selectedOgcType,
                regionId: selectedRegionId,
                alertType: formData.alertType ? formData.alertType.toUpperCase() : ''
            };
        }
        return {
            is_administrative: false,
            ogc_fid: null,
            ogc_type: ''
        };
    };

    // Optional thresholds — sent as numbers, or null when left blank
    const buildAlertThresholds = () => ({
        speedAlertKmh: formData.speedAlertKmh !== '' ? Number(formData.speedAlertKmh) : null,
        dwellAlertMinutes: formData.alertType !== 'OUT' && (formData.dwellHours !== '' || formData.dwellMins !== '')
            ? Number(formData.dwellHours || 0) * 60 + Number(formData.dwellMins || 0)
            : null
    });

    const handleAssignSubmit = async () => {
        if (!validateAssignForm()) return;

        if (waypoints.length === 0) {
            toast.error('No route waypoints found. Please select a different route or try again.', { position: 'top-center' });
            return;
        }

        setIsLoading(true);
        try {
            const selectedVehicleNumbers = formData.vehicleIds
                .map(id => vehicles.find(v => v.id === id)?.vehicleNumber)
                .filter(Boolean);
            const selectedRouteData = routes.find(r => r.id === parseInt(formData.routeId));

            const formatDateTime = (date, time) => {
                const d = new Date(date);
                const pad = (n) => String(n).padStart(2, "0");
                if (time) {
                    const [hours, minutes] = time.split(':');
                    d.setHours(parseInt(hours), parseInt(minutes), 0);
                } else {
                    d.setHours(0, 0, 0);
                }
                return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
            };

            const generateTimings = () => {
                const timings = [];
                const startDate = new Date(formData.fromDateTime);
                const endDate = new Date(formData.toDateTime);
                const currentDate = new Date(startDate);
                while (currentDate <= endDate) {
                    const dateStr = currentDate.toISOString().split('T')[0];
                    timings.push({
                        fromDate: formatDateTime(dateStr, formData.fromTime),
                        toDate: formatDateTime(dateStr, formData.toTime || formData.fromTime)
                    });
                    currentDate.setDate(currentDate.getDate() + 1);
                }
                return timings;
            };

            const formattedWaypoints = waypoints.map(waypoint => ({
                id: waypoint.id,
                routeId: waypoint.routeId,
                sequenceNo: waypoint.sequenceNo,
                latitude: parseFloat(waypoint.latitude),
                longitude: parseFloat(waypoint.longitude),
                pointType: waypoint.pointType,
                waitTime: waypoint.waitTime || 0,
                haltDuration: waypoint.haltDuration || null
            }));

            const payload = {
                vehicleNumbers: selectedVehicleNumbers,
                deviceId: null,
                routeId: parseInt(selectedRouteData.routeId),
                routeName: selectedRouteData?.routeName || "",
                startDate: formatDateTime(formData.fromDateTime, formData.fromTime),
                endDate: formatDateTime(formData.toDateTime, formData.toTime || formData.fromTime),
                timings: generateTimings(),
                type: "ASSIGNED ROUTE",
                createdBy: userId,
                waypoints: formattedWaypoints,
                ...buildGeofencePayload(),
                ...buildAdministrativeFields(),
                ...buildAlertThresholds()
            };

            console.log('Assign Route Payload:', JSON.stringify(payload, null, 2));

            const response = await postDataWithBody(createassignroute, payload, {});
            if (response) {
                if (response.status === 'success') {
                    toast.success(response.message, { position: 'top-center' });
                    resetForm();
                } else {
                    toast.error(response.message, { position: 'top-center' });
                }
            }
        } catch (error) {
            console.error('Error assigning route:', error);
            toast.error('Failed to assign route. Please try again.', { position: 'top-center' });
        } finally {
            setIsLoading(false);
        }
    };

    const handleUpdateRoute = async () => {
        if (!validateAssignForm()) return;

        setIsLoading(true);
        try {
            const selectedRouteData = routes.find(r => r.id === parseInt(formData.routeId));

            const formatDateTime = (date, time) => {
                const d = new Date(date);
                const pad = (n) => String(n).padStart(2, "0");
                if (time) {
                    const [hours, minutes] = time.split(':');
                    d.setHours(parseInt(hours), parseInt(minutes), 0);
                } else {
                    d.setHours(0, 0, 0);
                }
                return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
            };

            const payload = {
                id: editData.id,
                routeId: parseInt(selectedRouteData.routeId),
                routeName: selectedRouteData?.routeName || "",
                startDate: formatDateTime(formData.fromDateTime, formData.fromTime),
                endDate: formatDateTime(formData.toDateTime, formData.toTime),
                waypoints: waypoints,
                ...buildGeofencePayload(),
                ...buildAdministrativeFields(),
                ...buildAlertThresholds()
            };

            console.log('Update Route Payload:', JSON.stringify(payload, null, 2));

            const response = await putDataWithBody(updateplannedroute, payload, {});
            if (response) {
                if (response.status === 'success') {
                    toast.success(response.message || 'Route updated successfully', { position: 'top-center' });
                    resetForm();
                    setIsEditMode(false);
                    if (onEditModeChange) onEditModeChange(false);
                    navigate('/RoutePlanning/planned-route');
                } else {
                    toast.error(response.message, { position: 'top-center' });
                }
            }
        } catch (error) {
            console.error('Error updating route:', error);
            toast.error('Failed to update route. Please try again.', { position: 'top-center' });
        } finally {
            setIsLoading(false);
        }
    };

    // Render geofence geometry on map
    const renderGeofenceOnMap = () => {
        if (!selectedGeofence || !window.google || !isMapLoaded || selectionMode !== 'geofence') return null;

        const geo = selectedGeofence.geometry;
        const color = categoryColor(selectedGeofence.category) || selectedGeofence.color || '#1a7a73';

        if (geo.type === 'Circle' && geo.center) {
            return (
                <Circle
                    center={{ lat: geo.center.lat, lng: geo.center.lng }}
                    radius={geo.radius}
                    options={{
                        strokeColor: color,
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: color,
                        fillOpacity: 0.2,
                    }}
                />
            );
        }

        if (geo.type === 'Polygon' && geo.coordinates?.length > 0) {
            const paths = geo.coordinates.map(c => ({ lat: c[1], lng: c[0] }));
            return (
                <Polygon
                    paths={paths}
                    options={{
                        strokeColor: color,
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: color,
                        fillOpacity: 0.2,
                    }}
                />
            );
        }

        if (geo.type === 'LineString' && geo.coordinates?.length > 0) {
            const path = geo.coordinates.map(c => ({ lat: c[1], lng: c[0] }));
            return (
                <Polyline
                    path={path}
                    options={{
                        strokeColor: color,
                        strokeOpacity: 0.8,
                        strokeWeight: 4,
                    }}
                />
            );
        }

        return null;
    };

    const LAYERS = [
        { id: 'road',      label: 'Standard',  icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M3 15h18M9 3v18"/></svg> },
        { id: 'satellite', label: 'Satellite', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> },
        { id: 'terrain',   label: 'Terrain',   icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 18l-7-7-5 5-5-5"/><path d="M2 18h20"/></svg> },
        { id: 'hybrid',    label: 'Hybrid',    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5M2 12l10 5 10-5"/></svg> },
    ];

    const fieldLabel = (text, required = false) => (
            <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: '#64748b', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                {text}{required && <span style={{ color: '#ef4444', marginLeft: 3 }}>*</span>}
            </label>
        );

        const sectionHeader = (title) => (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '20px 0 14px', paddingBottom: 8, borderBottom: '1.5px solid #f1f5f9' }}>
                <div style={{ width: 3, height: 14, background: 'linear-gradient(180deg, #0f4a45, #1a7a73)', borderRadius: 2, flexShrink: 0 }} />
                <span style={{ fontSize: 11, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.07em' }}>{title}</span>
            </div>
        );

        return (
        <>
            <style>{`
        .agf-input, .agf-select {
            width: 100%; padding: 9px 12px; border-radius: 9px;
            border: 1.5px solid #e2e8f0; font-size: 13px; color: #0f172a;
            background: #fff; outline: none; transition: border-color 0.18s;
            box-sizing: border-box;
        }
        .agf-input:focus, .agf-select:focus { border-color: #0f4a45; box-shadow: 0 0 0 3px rgba(26,122,115,0.12); }
        .agf-input:disabled, .agf-select:disabled { background: #f8fafc; color: #94a3b8; cursor: not-allowed; }
        /* Global DatePicker.css paints a calendar on every picker icon — use a clock for time fields */
        .agf-input[type="time"]::-webkit-calendar-picker-indicator {
            background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23475569' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><circle cx='12' cy='12' r='10'/><polyline points='12 6 12 12 16 14'/></svg>");
            background-repeat: no-repeat; background-position: center; background-size: 16px 16px; cursor: pointer;
        }
        .agf-radio-pill { display: flex; gap: 8px; }
        .agf-radio-pill label {
            flex: 1; text-align: center; padding: 8px 12px; border-radius: 8px;
            border: 1.5px solid #e2e8f0; font-size: 12px; font-weight: 600;
            cursor: pointer; transition: all 0.18s; color: #64748b; background: #fff;
        }
        .agf-radio-pill input[type="radio"] { display: none; }
        .agf-radio-pill input[type="radio"]:checked + label {
            background: #ccfbf1; border-color: #0f4a45; color: #0f4a45;
        }
        .agf-btn-reset {
            flex: 1; padding: 10px; border-radius: 9px; font-size: 13px; font-weight: 600;
            border: 1.5px solid #d1dbe8; background: #f0f8fb; color: #0f4a45; cursor: pointer;
            transition: all 0.18s;
        }
        .agf-btn-reset:hover { background: #ccfbf1; border-color: #7ab8d8; }
        .agf-btn-submit {
            flex: 1; padding: 10px; border-radius: 9px; font-size: 13px; font-weight: 700;
            border: none; background: linear-gradient(135deg, #0f4a45 0%, #1a7a73 100%); color: #fff; cursor: pointer;
            transition: all 0.18s; display: flex; align-items: center; justify-content: center; gap: 6px;
            box-shadow: 0 4px 12px rgba(26,122,115,0.3);
        }
        .agf-btn-submit:hover { background: linear-gradient(135deg, #155a8a 0%, #0f4a45 100%); box-shadow: 0 6px 16px rgba(26,122,115,0.4); }
        .agf-btn-submit:disabled, .agf-btn-reset:disabled { opacity: 0.55; cursor: not-allowed; }
        @keyframes spin { to { transform: rotate(360deg); } }
        .gm-style .gm-style-iw-c { padding: 8px 8px 4px 8px !important; }
        .gm-style .gm-style-iw-d { overflow: hidden !important; padding-right: 4px !important; }
        .gm-style .gm-style-iw-chr { height: 24px !important; }
        .gm-style .gm-style-iw-chr button { width: 24px !important; height: 24px !important; top: 0 !important; right: 0 !important; }
        .gm-style .gm-style-iw-chr button span { width: 14px !important; height: 14px !important; margin: 0 !important; }
    `}</style>
            <div style={{ display: 'flex', height: '100vh', fontFamily: "'DM Sans', sans-serif", padding: '14px 16px', gap: 16, background: '#f0f4f8', boxSizing: 'border-box' }}>

                {/* ── LEFT PANEL ── */}
                <div style={{ width: 360, minWidth: 360, background: '#ffffff', display: 'flex', flexDirection: 'column', overflow: 'hidden', border: '1px solid #dee2e6', borderRadius: 8, boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }}>

                    {/* Panel Header */}
                    <div style={{ padding: '14px 20px 13px', borderBottom: '1px solid rgba(255,255,255,0.15)', background: 'linear-gradient(to right, #0f3d3a 0%, #0f4a45 50%, #1a7a73 100%)', flexShrink: 0 }}>
                        <div style={{ color: '#fff', fontWeight: 700, fontSize: 14, lineHeight: 1.3 }}>Assign Geofence</div>
                        <div style={{ color: 'rgba(255,255,255,0.72)', fontSize: 11, marginTop: 3 }}>Assign geofences to vehicle routes with alert schedules</div>
                    </div>

                    {/* Scrollable Form */}
                    <div style={{ flex: 1, overflowY: 'auto', padding: '16px 20px 20px' }}>
                        {isLoading && <LoadingOverlay message="Loading data..." />}

                        {sectionHeader('Vehicle & Route')}

                        <div style={{ marginBottom: 16 }}>
                            {fieldLabel('Vehicle Number', true)}
                            <div style={{ position: 'relative' }}>
                                {/* Trigger */}
                                <div
                                    onClick={() => !isEditMode && setVehicleDropdownOpen(o => !o)}
                                    style={{
                                        height: 40, padding: '0 32px 0 12px',
                                        border: `1.5px solid ${vehicleDropdownOpen ? '#0f4a45' : '#e2e8f0'}`,
                                        borderRadius: 9, background: isEditMode ? '#f8fafc' : '#fff',
                                        cursor: isEditMode ? 'not-allowed' : 'pointer',
                                        display: 'flex', alignItems: 'center',
                                        position: 'relative',
                                    }}
                                >
                                    {formData.vehicleIds.length === 0 ? (
                                        <span style={{ fontSize: 13, color: '#94a3b8' }}>Choose vehicles</span>
                                    ) : (
                                        <span style={{ fontSize: 13, color: '#0f172a', fontWeight: 600 }}>
                                            {formData.vehicleIds.length} vehicle{formData.vehicleIds.length > 1 ? 's' : ''} selected
                                        </span>
                                    )}
                                    <span style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', color: '#94a3b8', fontSize: 12 }}>
                                        {vehicleDropdownOpen ? '▲' : '▼'}
                                    </span>
                                </div>

                                {/* Dropdown panel */}
                                {vehicleDropdownOpen && !isEditMode && (
                                    <div style={{
                                        position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 200,
                                        background: '#fff', border: '1.5px solid #e2e8f0', borderRadius: 9,
                                        boxShadow: '0 4px 16px rgba(0,0,0,0.12)', marginTop: 4,
                                    }}>
                                        <div style={{ padding: '8px 8px 4px' }}>
                                            <input
                                                autoFocus
                                                type="text"
                                                placeholder="Search vehicles..."
                                                value={vehicleSearch}
                                                onChange={e => setVehicleSearch(e.target.value)}
                                                style={{
                                                    width: '100%', padding: '6px 10px', fontSize: 12,
                                                    border: '1.5px solid #e2e8f0', borderRadius: 7,
                                                    outline: 'none', boxSizing: 'border-box',
                                                }}
                                            />
                                        </div>
                                        {/* Select All row */}
                                        {(() => {
                                            const filtered = vehicles.filter(v => v.vehicleNumber.toLowerCase().includes(vehicleSearch.toLowerCase()));
                                            const allFilteredSelected = filtered.length > 0 && filtered.every(v => formData.vehicleIds.includes(v.id));
                                            return filtered.length > 0 && (
                                                <div
                                                    onClick={() => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            vehicleIds: allFilteredSelected
                                                                ? prev.vehicleIds.filter(id => !filtered.some(v => v.id === id))
                                                                : [...new Set([...prev.vehicleIds, ...filtered.map(v => v.id)])]
                                                        }));
                                                        setVehicleDropdownOpen(false);
                                                        setVehicleSearch('');
                                                    }}
                                                    style={{
                                                        display: 'flex', alignItems: 'center', gap: 8,
                                                        padding: '7px 12px', cursor: 'pointer', fontSize: 13,
                                                        fontWeight: 600, color: '#0f172a',
                                                        borderBottom: '1px solid #e2e8f0',
                                                        background: allFilteredSelected ? '#f0f9ff' : '#fafafa',
                                                    }}
                                                >
                                                    <input type="checkbox" checked={allFilteredSelected} readOnly style={{ accentColor: '#0f4a45' }} />
                                                    Select All
                                                </div>
                                            );
                                        })()}
                                        <div style={{ maxHeight: 180, overflowY: 'auto', padding: '4px 0' }}>
                                            {vehicles
                                                .filter(v => v.vehicleNumber.toLowerCase().includes(vehicleSearch.toLowerCase()))
                                                .map(v => {
                                                    const checked = formData.vehicleIds.includes(v.id);
                                                    return (
                                                        <div
                                                            key={v.id}
                                                            onClick={() => setFormData(prev => ({
                                                                ...prev,
                                                                vehicleIds: checked
                                                                    ? prev.vehicleIds.filter(x => x !== v.id)
                                                                    : [...prev.vehicleIds, v.id]
                                                            }))}
                                                            style={{
                                                                display: 'flex', alignItems: 'center', gap: 8,
                                                                padding: '7px 12px', cursor: 'pointer', fontSize: 13,
                                                                background: checked ? '#f0f9ff' : 'transparent',
                                                                color: checked ? '#1a7a73' : '#0f172a',
                                                            }}
                                                        >
                                                            <input type="checkbox" checked={checked} readOnly style={{ accentColor: '#0f4a45' }} />
                                                            {v.vehicleNumber}
                                                        </div>
                                                    );
                                                })}
                                            {vehicles.filter(v => v.vehicleNumber.toLowerCase().includes(vehicleSearch.toLowerCase())).length === 0 && (
                                                <div style={{ padding: '10px 12px', fontSize: 12, color: '#94a3b8' }}>No vehicles found</div>
                                            )}
                                        </div>
                                        <div style={{ padding: '6px 12px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <button
                                                onClick={() => { setFormData(prev => ({ ...prev, vehicleIds: [] })); setVehicleSearch(''); }}
                                                style={{ fontSize: 11, color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}
                                            >Clear All</button>
                                            <button
                                                onClick={() => { setVehicleDropdownOpen(false); setVehicleSearch(''); }}
                                                style={{ fontSize: 11, color: '#0f4a45', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}
                                            >Done</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div style={{ marginBottom: 16 }}>
                            {/* {fieldLabel('Select Route', true)} */}
                                    <SearchableRouteDropdown
                                        routes={routes}
                                        selectedRoute={selectedRoute}
                                        setSelectedRoute={(route) => {
                                            setSelectedRoute(route);
                                            setFormData(prev => ({
                                                ...prev,
                                                routeId: route ? route.id.toString() : ''
                                            }));
                                        }}
                                        isLoading={isLoading}
                                    />
                        </div>

                        {sectionHeader('Schedule')}

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
                            <div>
                                {fieldLabel('From Date', true)}
                                <input
                                    type="date"
                                    className="agf-input"
                                    name="fromDateTime"
                                    value={formData.fromDateTime}
                                    onChange={handleInputChange}
                                    min={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                            <div>
                                {fieldLabel('To Date', true)}
                                <input
                                    type="date"
                                    className="agf-input"
                                    name="toDateTime"
                                    value={formData.toDateTime}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div>
                                {fieldLabel('From Time', true)}
                                <input
                                    type="time"
                                    className="agf-input"
                                    name="fromTime"
                                    value={formData.fromTime}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div>
                                {fieldLabel('To Time', true)}
                                <input
                                    type="time"
                                    className="agf-input"
                                    name="toTime"
                                    value={formData.toTime}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>

                        {sectionHeader('Geofence Area')}

                        {/* ── Selection Mode Toggle ── */}
                        <div style={{ marginBottom: 14 }}>
                            <div className="agf-radio-pill">
                                        <input
                                            type="radio"
                                            id="modeGeofence"
                                            checked={selectionMode === 'geofence'}
                                            onChange={() => {
                                                setSelectionMode('geofence');
                                                setDistrictPolygons([]);
                                                setRegionCheckedKeys([]);
                                                setSelectedOgcFid(null);
                                                setSelectedOgcType('');
                                                setSelectedRegionId(null);
                                            }}
                                        />
                                        <label htmlFor="modeGeofence">Custom Geofence</label>
                                        <input
                                            type="radio"
                                            id="modeDistrict"
                                            checked={selectionMode === 'district'}
                                            onChange={() => {
                                                setSelectionMode('district');
                                                setRegionTreeCollapsed(false);
                                                setFormData(prev => ({ ...prev, geofenceId: '', alertType: '' }));
                                                setSelectedGeofence(null);
                                                // Re-trigger auto-check if route has a region
                                                if (routeRegionRef.current) {
                                                    setRegionCheckedKeys([]);
                                                    setDistrictPolygons([]);
                                                    setPendingAutoRegion({ ...routeRegionRef.current });
                                                }
                                            }}
                                        />
                                        <label htmlFor="modeDistrict">Administrative Area</label>
                            </div>
                        </div>

                        {selectionMode === 'geofence' ? (
                            /* ── Geofence mode: side-by-side Geofence + Alert Type ── */
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
                                <div>
                                    {fieldLabel('Select Geofence', true)}
                                    <select
                                        className="form-select agf-select"
                                        name="geofenceId"
                                        value={formData.geofenceId}
                                        onChange={handleInputChange}
                                        disabled={isLoadingGeofences || (selectedRoute && routeGeofences.length === 0)}
                                    >
                                        <option value="">
                                            {isLoadingGeofences ? 'Loading...' : 'Select geofence'}
                                        </option>
                                        {(selectedRoute
                                            ? routeGeofences
                                            : geofences.filter(g => g.type !== 'Region' && g.zone !== 'administrative')
                                        ).map(geofence => (
                                            <option key={geofence.id} value={geofence.id}>
                                                {geofence.name || geofence.geofenceName}{geofence.category ? ` — ${geofence.category}` : ''}
                                            </option>
                                        ))}
                                    </select>
                                    {selectedRoute && routeGeofences.length === 0 && !isLoadingGeofences && (
                                        <div style={{ fontSize: 11, color: '#f97316', marginTop: 4 }}>No geofences linked to this route</div>
                                    )}
                                </div>
                                <div>
                                    {fieldLabel('Alert Type', true)}
                                    <select
                                        className="agf-select"
                                        name="alertType"
                                        value={formData.alertType}
                                        onChange={handleInputChange}
                                        disabled={!formData.geofenceId}
                                    >
                                        <option value="">Select type</option>
                                        <option value="IN">In</option>
                                        <option value="OUT">Out</option>
                                    </select>
                                    {!formData.geofenceId && (
                                        <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>Select geofence first</div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            /* ── District mode: full-width tree + alert type below ── */
                            <>
                                <div style={{ marginBottom: 14 }}>
                                    {fieldLabel('Select Geofence Area', true)}
                                    <div style={{ border: '1px solid #e2e8f0', borderRadius: 8, background: '#fafafa' }}>
                                        <div
                                            onClick={() => setRegionTreeCollapsed(c => !c)}
                                            style={{
                                                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                padding: '8px 12px', cursor: 'pointer', userSelect: 'none',
                                                borderBottom: regionTreeCollapsed ? 'none' : '1px solid #e2e8f0',
                                                borderRadius: regionTreeCollapsed ? 8 : '8px 8px 0 0',
                                            }}
                                        >
                                            <span style={{ fontSize: 13, fontWeight: 500, color: '#475569' }}>
                                                {regionCheckedKeys.length > 0
                                                    ? `${regionCheckedKeys.length} region selected`
                                                    : 'Select regions'}
                                            </span>
                                            <span style={{ fontSize: 16, color: '#94a3b8', lineHeight: 1 }}>
                                                {regionTreeCollapsed ? '▼' : '▲'}
                                            </span>
                                        </div>
                                        {!regionTreeCollapsed && (
                                            <div style={{ padding: 12, maxHeight: 240, overflowY: 'auto', position: 'relative' }}>
                                                {regionCheckLoading && (
                                                    <div style={{
                                                        position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.7)',
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10,
                                                        borderRadius: '0 0 8px 8px',
                                                    }}>
                                                        <span className="spinner-border spinner-border-sm text-info me-2" />
                                                        <small className="text-muted">Loading…</small>
                                                    </div>
                                                )}
                                                {!stateId ? (
                                                    <div className="text-muted small">Loading regions…</div>
                                                ) : regionTreeData.length === 0 ? (
                                                    <div className="text-muted small">No regions found.</div>
                                                ) : (
                                                    <Tree
                                                        treeData={regionTreeData}
                                                        checkable
                                                        checkStrictly
                                                        checkedKeys={regionCheckedKeys}
                                                        expandedKeys={regionExpandedKeys}
                                                        onExpand={setRegionExpandedKeys}
                                                        onCheck={onRegionCheck}
                                                        loadData={loadRegionChildren}
                                                        showLine
                                                    />
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div style={{ marginBottom: 16 }}>
                                    {fieldLabel('Alert Type', true)}
                                    <select
                                        className="agf-select"
                                        name="alertType"
                                        value={formData.alertType}
                                        onChange={handleInputChange}
                                        disabled={regionCheckedKeys.length === 0}
                                    >
                                        <option value="">Select alert type</option>
                                        <option value="IN">In</option>
                                        <option value="OUT">Out</option>
                                    </select>
                                    {regionCheckedKeys.length === 0 && (
                                        <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>Select a region to enable alert type</div>
                                    )}
                                </div>
                            </>
                        )}

                        {/* Optional alert thresholds */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
                            <div>
                                {fieldLabel('Speed Alert (km/h)')}
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={4}
                                    className="agf-input"
                                    name="speedAlertKmh"
                                    value={formData.speedAlertKmh}
                                    onChange={handleInputChange}
                                    placeholder="Optional"
                                />
                            </div>
                            <div>
                                {fieldLabel('Dwell Alert')}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={2}
                                        className="agf-input"
                                        name="dwellHours"
                                        value={formData.dwellHours}
                                        onChange={handleInputChange}
                                        placeholder="Hrs"
                                        disabled={formData.alertType === 'OUT'}
                                    />
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={2}
                                        className="agf-input"
                                        name="dwellMins"
                                        value={formData.dwellMins}
                                        onChange={handleInputChange}
                                        placeholder="Min"
                                        disabled={formData.alertType === 'OUT'}
                                    />
                                </div>
                                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>
                                    {formData.alertType === 'OUT'
                                        ? 'Not applicable for Out alerts'
                                        : 'Optional · hours and minutes'}
                                </div>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
                            <button className="agf-btn-reset" onClick={resetForm} disabled={isLoading}>
                                {isEditMode ? 'Cancel' : 'Reset'}
                            </button>
                            <button
                                className="agf-btn-submit"
                                onClick={isEditMode ? handleUpdateRoute : handleAssignSubmit}
                                disabled={isLoading || isLoadingWaypoints || !formData.vehicleIds.length || !formData.routeId}
                            >
                                {isLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" style={{ width: 14, height: 14, borderWidth: 2 }}></span>
                                        {isEditMode ? 'Updating...' : 'Assigning...'}
                                    </>
                                ) : (
                                    isEditMode ? 'Update Route' : 'Assign Route'
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                {/* ── RIGHT MAP PANEL ── */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, border: '1px solid #dee2e6', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }}>

                    {/* Map Section Header */}
                    {!isFullscreen && (
                        <div style={{
                            padding: '5px 14px',
                            background: 'linear-gradient(to right, #0f3d3a 0%, #0f4a45 50%, #1a7a73 100%)',
                            flexShrink: 0, display: 'flex', alignItems: 'center', gap: 8,
                        }}>
                            <div style={{ width: 26, height: 26, borderRadius: 6, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/>
                                    <line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/>
                                </svg>
                            </div>
                            <span style={{ color: '#fff', fontWeight: 700, fontSize: 13, flex: 1 }}>Geofence Map</span>
                            <span style={{ background: 'rgba(255,255,255,0.18)', color: '#fff', border: '1px solid rgba(255,255,255,0.3)', borderRadius: 20, padding: '2px 9px', fontSize: 10, fontWeight: 600, flexShrink: 0 }}>
                                {(LAYERS.find(l => l.id === selectedLayer)?.label ?? selectedLayer)} layer
                            </span>
                        </div>
                    )}

                    {/* Search bar */}
                    {!isFullscreen && (
                        <div style={{ padding: '8px 12px', background: '#fff', borderBottom: '1px solid #e2e8f0', position: 'relative', flexShrink: 0 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#fff', border: '1.5px solid #e2e8f0', borderRadius: 9, padding: '6px 10px' }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                                    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                                </svg>
                                <input
                                    type="text"
                                    value={searchQuery}
                                    onChange={handleSearchInputChange}
                                    placeholder="Search city, area, landmark or coordinates…"
                                    style={{ flex: 1, border: 'none', outline: 'none', fontSize: 13, color: '#0f172a', background: 'transparent', fontFamily: "'DM Sans', sans-serif" }}
                                />
                                {isSearching && (
                                    <div style={{ width: 14, height: 14, border: '2px solid #e2e8f0', borderTop: '2px solid #0f4a45', borderRadius: '50%', animation: 'spin 0.7s linear infinite', flexShrink: 0 }} />
                                )}
                                {searchQuery && !isSearching && (
                                    <button onClick={clearSearch} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, color: '#94a3b8', display: 'flex', alignItems: 'center' }}>
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                                    </button>
                                )}
                            </div>
                            {searchResults.length > 0 && (
                                <div style={{ position: 'absolute', top: '100%', left: 12, right: 12, background: '#fff', border: '1px solid #e2e8f0', borderRadius: '0 0 10px 10px', boxShadow: '0 8px 24px rgba(0,0,0,0.12)', zIndex: 1050, maxHeight: 260, overflowY: 'auto' }}>
                                    {searchResults.map((result) => (
                                        <div
                                            key={result.place_id}
                                            onClick={() => selectSearchResult(result)}
                                            style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid #f1f5f9', transition: 'background 0.15s' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.background = '#f8fafc'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                                        >
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="#ef4444" stroke="none" style={{ flexShrink: 0, marginTop: 2 }}>
                                                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                                            </svg>
                                            <div>
                                                <div style={{ fontSize: 13, fontWeight: 600, color: '#0f172a' }}>{result.structured_formatting?.main_text || result.description}</div>
                                                {result.structured_formatting?.secondary_text && (
                                                    <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 1 }}>{result.structured_formatting.secondary_text}</div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}

                    <div ref={mapPanelRef} style={{ flex: 1, position: 'relative', width: '100%' }}>
                                {(!isMapLoaded || isLoadingWaypoints) && (
                                    <div className="position-absolute top-50 start-50 translate-middle z-3 bg-white bg-opacity-75 p-4 rounded shadow">
                                        <div className="text-center">
                                            <div className="spinner-border text-primary mb-2" style={{ width: '3rem', height: '3rem' }}></div>
                                            <p className="mb-0">
                                                {!isMapLoaded ? 'Loading Google Maps...' : 'Loading route data...'}
                                            </p>
                                        </div>
                                    </div>
                                )}

                                {isMapsApiReady ? (
                                    <GoogleMap
                                        mapContainerStyle={mapContainerStyle}
                                        center={mapCenter}
                                        zoom={mapZoom}
                                        onLoad={onMapLoad}
                                        options={{
                                            ...defaultMapOptions,
                                            mapTypeId: mapTypes[selectedLayer],
                                            minZoom: 4,
                                        }}
                                        minzoom={4}
                                    >
                                        {showTransit && <TransitLayer />}
                                        {isMapLoaded && (
                                            <>
                                                {/* Geofence Geometry */}
                                                {renderGeofenceOnMap()}

                                                {/* Region Polygons – state/district/block */}
                                                {districtPolygons.flatMap((dp, i) => {
                                                    const clr = polygonColorByLevel(dp.level ?? 1);
                                                    return dp.paths.map((path, j) => (
                                                        <Polygon
                                                            key={`dp-${i}-${j}`}
                                                            paths={path}
                                                            options={{
                                                                strokeColor: clr.stroke,
                                                                strokeOpacity: 0.9,
                                                                strokeWeight: dp.level === 0 ? 3 : 2,
                                                                fillColor: clr.fill,
                                                                fillOpacity: clr.opacity,
                                                            }}
                                                            onMouseOver={(e) => {
                                                                const dom = e.domEvent;
                                                                if (dom && mapPanelRef.current) {
                                                                    const rect = mapPanelRef.current.getBoundingClientRect();
                                                                    setHoveredPolygon({ name: dp.name, x: dom.clientX - rect.left, y: dom.clientY - rect.top });
                                                                }
                                                            }}
                                                            onMouseMove={(e) => {
                                                                const dom = e.domEvent;
                                                                if (dom && mapPanelRef.current) {
                                                                    const rect = mapPanelRef.current.getBoundingClientRect();
                                                                    setHoveredPolygon(prev => prev ? { ...prev, x: dom.clientX - rect.left, y: dom.clientY - rect.top } : null);
                                                                }
                                                            }}
                                                            onMouseOut={() => setHoveredPolygon(null)}
                                                        />
                                                    ));
                                                })}



                                                {/* Route Waypoint Markers */}
                                                {waypoints.filter(point => getIconColor(point.pointType) !== '#1a7a73')
                                                    .map((point, index) => {
                                                        const cacheKey = `${point.latitude}_${point.longitude}`;
                                                        const position = {
                                                            lat: parseFloat(point.latitude),
                                                            lng: parseFloat(point.longitude)
                                                        };
                                                        const pointType = point.pointType?.toLowerCase();
                                                        const icon = createMarkerIcon(getIconColor(point.pointType), pointType);

                                                        return icon && (
                                                            <Marker
                                                                key={point.id || index}
                                                                position={position}
                                                                icon={icon}
                                                                onClick={() => {
                                                                    setSelectedMarker({ position, point, cacheKey });
                                                                    fetchAddress(point.latitude, point.longitude, cacheKey);
                                                                }}
                                                            />
                                                        );
                                                    })}

                                                {/* InfoWindow for selected marker */}
                                                {selectedMarker && (
                                                    <InfoWindow
                                                        position={selectedMarker.position}
                                                        onCloseClick={() => setSelectedMarker(null)}
                                                    >
                                                        {(() => {
                                                            const pt = selectedMarker.point.pointType?.toLowerCase();
                                                            const color = getIconColor(selectedMarker.point.pointType);
                                                            const title =
                                                                pt === 'start' ? 'Start Point' :
                                                                pt === 'end'   ? 'End Point' :
                                                                pt === 'halt'  ? `Halt Point ${selectedMarker.point.sequenceNo || ''}`.trim() :
                                                                `Waypoint ${selectedMarker.point.sequenceNo || ''}`;
                                                            const subtitle =
                                                                pt === 'start' ? 'Planned starting location' :
                                                                pt === 'end'   ? 'Planned ending location' :
                                                                pt === 'halt'  ? 'Scheduled stop location' :
                                                                'Route waypoint';
                                                            const headerIcon =
                                                                pt === 'halt'
                                                                    ? <svg width="16" height="16" viewBox="0 0 24 24" fill="white"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>
                                                                    : <svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>;
                                                            return (
                                                                <div style={{
                                                                    minWidth: 260, maxWidth: 300,
                                                                    borderRadius: 10, overflow: 'hidden',
                                                                    fontFamily: "'Segoe UI', system-ui, sans-serif",
                                                                    boxShadow: '0 2px 12px rgba(0,0,0,0.14)'
                                                                }}>
                                                                    {/* ── Coloured header ── */}
                                                                    <div style={{
                                                                        background: color,
                                                                        padding: '13px 16px',
                                                                        display: 'flex', alignItems: 'center', gap: 12
                                                                    }}>
                                                                        <div style={{
                                                                            width: 36, height: 36, borderRadius: '50%',
                                                                            background: 'rgba(255,255,255,0.22)',
                                                                            display: 'flex', alignItems: 'center',
                                                                            justifyContent: 'center', flexShrink: 0
                                                                        }}>
                                                                            {headerIcon}
                                                                        </div>
                                                                        <div>
                                                                            <div style={{ color: '#fff', fontWeight: 700, fontSize: 14.5, lineHeight: 1.3 }}>
                                                                                {title}
                                                                            </div>
                                                                            <div style={{ color: 'rgba(255,255,255,0.82)', fontSize: 11.5, marginTop: 2 }}>
                                                                                {subtitle}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {/* ── Body ── */}
                                                                    <div style={{ background: '#fff', padding: '14px 16px 16px 16px' }}>
                                                                        {/* Wait time — halt only */}
                                                                        {pt === 'halt' && (
                                                                            <div style={{ marginBottom: 14 }}>
                                                                                <div style={{
                                                                                    fontSize: 10, color: '#94a3b8', fontWeight: 700,
                                                                                    textTransform: 'uppercase', letterSpacing: '0.7px',
                                                                                    marginBottom: 4, display: 'flex', alignItems: 'center', gap: 5
                                                                                }}>
                                                                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                                                                                    WAIT TIME
                                                                                </div>
                                                                                <div style={{ fontSize: 15, fontWeight: 700, color: '#0f172a' }}>
                                                                                    {selectedMarker.point.waitTime ? `${selectedMarker.point.waitTime} minutes` : '—'}
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                        {/* Location */}
                                                                        <div>
                                                                            <div style={{
                                                                                fontSize: 10, color: '#94a3b8', fontWeight: 700,
                                                                                textTransform: 'uppercase', letterSpacing: '0.7px',
                                                                                marginBottom: 6, display: 'flex', alignItems: 'center', gap: 5
                                                                            }}>
                                                                                <svg width="11" height="11" viewBox="0 0 24 24" fill="#94a3b8"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/></svg>
                                                                                LOCATION
                                                                            </div>
                                                                            <div style={{
                                                                                fontSize: 13, color: '#334155', lineHeight: 1.55,
                                                                                paddingLeft: 12, paddingTop: 2, paddingBottom: 2,
                                                                                borderLeft: `3px solid ${color}`
                                                                            }}>
                                                                                {addressCache[selectedMarker.cacheKey]
                                                                                    ? addressCache[selectedMarker.cacheKey]
                                                                                    : <span style={{ color: '#94a3b8', fontStyle: 'italic' }}>Loading address…</span>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })()}
                                                    </InfoWindow>
                                                )}

                                                {/* Route Polyline */}
                                                {waypoints.length > 1 && (
                                                    <Polyline
                                                        path={waypoints.map(point => ({
                                                            lat: parseFloat(point.latitude),
                                                            lng: parseFloat(point.longitude)
                                                        }))}
                                                        options={{
                                                            strokeColor: '#1a7a73',
                                                            strokeOpacity: 0.8,
                                                            strokeWeight: 5,
                                                        }}
                                                    />
                                                )}
                                            </>
                                        )}
                                    </GoogleMap>
                                ) : (
                                    <div style={{
                                        height: '100%', display: 'flex',
                                        alignItems: 'center', justifyContent: 'center'
                                    }}>
                                        <div className="text-center">
                                            <div className="spinner-border text-primary mb-2"
                                                style={{ width: '3rem', height: '3rem' }}></div>
                                            <p className="mb-0">Loading Google Maps...</p>
                                        </div>
                                    </div>
                                )}

                                {/* Block name tooltip — no close button, follows cursor */}
                                {hoveredPolygon && (
                                    <div style={{
                                        position: 'absolute',
                                        left: hoveredPolygon.x + 14,
                                        top: hoveredPolygon.y - 36,
                                        zIndex: 1001,
                                        background: 'rgba(15,23,42,0.88)',
                                        color: '#fff',
                                        padding: '5px 11px',
                                        borderRadius: 6,
                                        fontSize: 13,
                                        fontWeight: 600,
                                        pointerEvents: 'none',
                                        whiteSpace: 'nowrap',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.28)',
                                        backdropFilter: 'blur(4px)',
                                    }}>
                                        {hoveredPolygon.name}
                                    </div>
                                )}

                                {/* Fullscreen toggle — top-right */}
                                <div style={{ position: 'absolute', top: 9, right: 9, zIndex: 1000 }}>
                                    <button
                                        title={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
                                        onClick={() => { if (!document.fullscreenElement) mapPanelRef.current?.requestFullscreen(); else document.exitFullscreen(); }}
                                        style={{ width: 40, height: 40, borderRadius: 10, background: '#fff', border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                                    >
                                        {isFullscreen
                                            ? <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#475569"><path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/></svg>
                                            : <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#475569"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>}
                                    </button>
                                </div>

                                {/* Layer switcher — below fullscreen button */}
                                <div style={{ position: 'absolute', top: 58, right: 9, zIndex: 1000 }}>
                                    <button onClick={() => setShowLayerControl(p => !p)} style={{ width: 40, height: 40, border: 'none', background: 'white', borderRadius: 8, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <polygon points="12 2 2 7 12 12 22 7 12 2"/>
                                            <polyline points="2 17 12 22 22 17"/>
                                            <polyline points="2 12 12 17 22 12"/>
                                        </svg>
                                    </button>
                                    {showLayerControl && (
                                        <div style={{ position: 'absolute', top: 45, right: 0, background: 'white', borderRadius: 10, padding: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.14)', minWidth: 160, border: '1px solid #e2e8f0' }}>
                                            {LAYERS.map(l => (
                                                <div key={l.id} onClick={() => { setSelectedLayer(l.id); setShowLayerControl(false); }} style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '8px 10px', borderRadius: 7, cursor: 'pointer', background: selectedLayer === l.id ? '#f0fdfb' : 'transparent', transition: 'background 0.15s' }}>
                                                    <span style={{ color: selectedLayer === l.id ? '#1a7a73' : '#94a3b8' }}>{l.icon}</span>
                                                    <span style={{ fontSize: 13, fontWeight: selectedLayer === l.id ? 600 : 400, color: selectedLayer === l.id ? '#1a7a73' : '#334155' }}>{l.label}</span>
                                                    {selectedLayer === l.id && <span style={{ marginLeft: 'auto', width: 7, height: 7, borderRadius: '50%', background: '#1a7a73' }} />}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Transit toggle */}
                                <button
                                    onClick={() => setShowTransit(p => !p)}
                                    title={showTransit ? "Hide transit" : "Show transit"}
                                    style={{
                                        position: 'absolute', top: 107, right: 9, zIndex: 1000,
                                        width: 40, height: 40, borderRadius: 8, border: 'none', cursor: 'pointer',
                                        background: showTransit ? '#1a7a73' : 'white',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                    }}
                                >
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                        stroke={showTransit ? '#fff' : '#555'} strokeWidth="2"
                                        strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="4" y="2" width="16" height="16" rx="2"/>
                                        <path d="M4 10h16"/><path d="M8 2v8"/><path d="M16 2v8"/>
                                        <path d="M8 18l-2 4"/><path d="M16 18l2 4"/>
                                    </svg>
                                </button>
                    </div>
                </div>
            </div>
        </>
    );
};



export default AssignGeofencing;